module.exports = __webpack_public_path__ + "static/media/iconPenLastStepHorizontal.80309ec5.svg";